import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

import SubtitleRegular from 'components/Typography/SubtitleRegular';
import StatusDot from 'components/Relatorios/shared/Aprovacao/StatusDot';
import useRelatorioAprovacao from 'hooks/Relatorios/Aprovacao/useRelatorioAprovacao';
import useSecoesDoInforme from 'hooks/Relatorios/Aprovacao/useSecoesDoInforme';

import './index.scss';

/**
 * Sub-abas do informe (visão do cliente). Replica a marcação/classes de
 * `DesignSystem/Tabs/DiscreteTabs` (NÃO a modifica — decisão Q7 do plano),
 * e acrescenta, em `modoRevisao`, um `StatusDot` depois do rótulo de cada seção, um divisor e o
 * link "Aprovação".
 */
export default function SecaoTabs() {
  const location = useLocation();
  const { config, modoRevisao, statusPorSlug } = useRelatorioAprovacao();
  const { base } = config;
  const secoes = useSecoesDoInforme(config);
  const rotaAprovacao = `${base}/aprovacao`;

  return (
    <Nav activeKey={location.pathname} className="underline-discrete-tabs relatorio-aprovacao-secao-tabs">
      {secoes.map(({ slug, label }) => {
        const rota = `${base}/${slug}`;
        const secao = statusPorSlug[slug];

        return (
          <Link
            key={slug}
            to={rota}
            className={`discrete-nav-link ${location.pathname === rota ? 'active' : ''}`}
          >
            <SubtitleRegular>{label}</SubtitleRegular>
            {modoRevisao && secao && <StatusDot status={secao.status} />}
          </Link>
        );
      })}

      {modoRevisao && (
        <>
          <span className="relatorio-aprovacao-secao-tabs__divisor" aria-hidden="true" />
          <Link
            to={rotaAprovacao}
            className={`discrete-nav-link relatorio-aprovacao-secao-tabs__aprovacao ${location.pathname === rotaAprovacao ? 'active' : ''}`}
          >
            <SubtitleRegular>Aprovação</SubtitleRegular>
          </Link>
        </>
      )}
    </Nav>
  );
}
